export default {
  USD: "USD", // United States
  EUR: "EUR", // European Union
  JPY: "JPY", // Japan
  GBP: "GBP", // United Kingdom
  CHF: "CHF", // Switzerland
  CAD: "CAD", // Canada
  AUD: "AUD", // Australia
  NZD: "NZD", // New Zealand
  CNY: "CNY", // China
  RUB: "RUB" // Russia
};
